import classNames from 'classnames';
import React from 'react';

interface TableHeaderProps {
  children: any;
  noBorderTop?: boolean;
  withoutSearch?: boolean;
  withCheckbox?: boolean;
  withHeaderAddon?: boolean;
}

const TableHeader = ({
  children,
  noBorderTop,
  withCheckbox,
  withoutSearch,
  withHeaderAddon,
}: TableHeaderProps) => {
  return (
    <div
      className={classNames('table-header', {
        'table-header--no-border-top': noBorderTop,
        'table-header--without-search': withoutSearch,
        'table-header--with-checkbox': withCheckbox,
        'table-header--with-headder-addon': withHeaderAddon,
      })}
    >
      {children}
    </div>
  );
};

export default TableHeader;
